// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	EditSalePriceAdjustmentLink: 'edit-sale-price-adjustment-link',
	GoToPropertyDetailsLink: 'go-to-property-details-link',
	EditFinanceSettingsButton: 'edit-finance-settings-button',
	GoToTeranetExpressButton: 'go-to-teranet-express-button',
	ApplyChattelsAndOtherConsiderationsCheckbox:
		'apply-chattels-and-other-considerations-checkbox',
	ApplyFirstTimeHomeBuyerRefundCheckbox:
		'apply-first-time-home-buyer-refund-checkbox',
	ApplyMlttCalculationsCheckbox: 'apply-mltt-calculations-checkbox',
	ApplyHSTCheckbox: 'apply-hst-checkbox',
	ApplyNRSTCheckbox: 'apply-nrst-checkbox',
	ApplyMNRSTCheckbox: 'apply-mnrst-checkbox',
	ContentHeader: 'content-header',
	LttAffidavitExecutedByDropdown: 'ltt-affidavit-executed-by-dropdown',
	LttRateBasedOnDropdown: 'ltt-rate-based-on-dropdown',
	ValueOfSingleFamilyResidence: 'value-of-single-family-residence',
	RestOfTheLandUsedFor: 'rest-of-the-land-used-for',
	AssumedMortgageInput: 'assumed-mortgage-input',
	PropertyTransferred: 'property-transferred',
	PercentageClaimed: 'percentage-claimed',
	ValueOfAllChattels: 'value-of-all-chattels',
	OtherConsiderations: 'other-considerations',
	ConsiderationssSubjecttoTax: 'considerationss-subjectto-tax',
	MLTTAdminFeeInput: 'mltt-admin-fee-input',
	PercentageApplied: 'percentage-applied',
	NrstRemittanceReceiptNumber: 'nrst-remittance-receipt-number',
	SetMRSTPercentageApplied: 'set-mrst-percentage-applied',
	MnrstRemittanceReceiptNumber: 'mnrst-remittance-receipt-number',
	PrescribedConfirmationNumber: 'prescribed-confirmation-number',
	LTTCalculationLockableInput: 'ltt-calculation-lockable-input',
	ReturnedToVendorLockableInput: 'returned-to-vendor-lockable-input',
	FirstTimeHomeBuyerOnMatterNote: 'first-time-home-buyer-on-matter-note',
	LroOnMatterDoesNotMatchNote: 'lro-on-matter-does-not-match-note',
	Page: 'page',
	DetailsSection: 'details-section',
	NonResidentSpeculationTaxSection: 'non-resident-speculation-tax-section',
	SummarySection: 'summary-section',
	SetConfirmationNumberLink: 'set-confirmation-number-link',
	VmGoToPropertyDetailsSpan: 'vm-go-to-property-details-span',
	NetAmountPayable: 'net-amount-payable',
	ValuesSubjectToLTT: 'values-subject-to-ltt',
	NRSTAmount: 'nrst-amount',
	MNRSTAmount: 'mnrst-amount',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
